<script setup>
import ModuleTable from '@frontJs/components/tables/ModuleTable.vue';
import TenantReportModuleTable from '@frontJs/components/tables/tenantReports/ModuleTable.vue';
import DefaultLayout from '@frontJs/layouts/DefaultLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: DefaultLayout });
</script>

<template>
    <Head>
        <title>Modules - Datakepler</title>
    </Head>

    <PageTitle> Modules </PageTitle>

    <TabLayout
        :tabs="{
            modules: {
                title: 'Modules',
                content: h(ModuleTable),
            },
            eCommerce: {
                title: 'E-commerce',
                content: h(TenantReportModuleTable, { type: 'e-commerce' }),
            },
            showcase: {
                title: 'Vitrine',
                content: h(TenantReportModuleTable, { type: 'showcase' }),
            },
            marketplace: {
                title: 'Marketplace',
                content: h(TenantReportModuleTable, { type: 'marketplace' }),
            },
            shop: {
                title: 'Boutique',
                content: h(TenantReportModuleTable, { type: 'shop' }),
            },
            customMade: {
                title: 'Sur-mesure',
                content: h(TenantReportModuleTable, { type: 'custom-made' }),
            },
            other: {
                title: 'Autre',
                content: h(TenantReportModuleTable, { type: 'other' }),
            },
        }"
    />
</template>
